const ORIGIN = {
  standard: "standard", // App Mobile usuario final
  rrppSell: "rrppsell", // App Mobile cuando vende relaciones publicas
  producer: "producer", // App Mobile cuando vende el productor
  producerBO: "producer-bo", // Back Office cuando vende el productor.
  gift: "gift-bo", // Regalos
  loyaly: "loyaly", // Loyaly
};


module.exports = { ORIGIN:ORIGIN };



// WEBPACK FOOTER //
// ./src/common/Constants.js